import { render, staticRenderFns } from "./DesignerV2.vue?vue&type=template&id=5afd7407&scoped=true&"
import script from "./DesignerV2.vue?vue&type=script&lang=js&"
export * from "./DesignerV2.vue?vue&type=script&lang=js&"
import style0 from "./DesignerV2.vue?vue&type=style&index=0&id=5afd7407&lang=scss&scoped=true&"
import style1 from "./DesignerV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd7407",
  null
  
)

export default component.exports